module.exports = __webpack_public_path__ + "img/bkl10.3be8df49.jpg";